import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationService } from '@sphere/platform';

@NgModule({
    imports: [RouterModule]
})
export class NavigationModule {
    static forRoot(): ModuleWithProviders<NavigationModule> {
        return {
            ngModule: NavigationModule,
            providers: [NavigationService]
        };
    }
}
